// Generated by scripts/update-seeq-icons.js from src/svg/seeq/scalar.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcScalar = {
  prefix: 'fak',
  iconName: 'scalar' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f911',
    'M778.2 824.3l-56.3-163.8h97.3v-138.3h-143.4l-40.9-128c-5.1-15.4-15.4-20.5-30.7-25.6-15.4 0-25.6 5.1-30.8 20.5l-66.5 133.1h-71.7l-102.4-414.7c-5.1-10.2-15.4-25.6-35.8-25.6-15.4 0-30.7 10.2-30.8 25.6l-81.9 409.6h-184.3v138.3h158.7l-30.7 153.6v122.8c5.1 5.1 10.2 5.1 15.4 5.2s5.1 0 10.2 0c15.4-5.1 25.6-15.4 25.6-25.6l122.9-634.9 61.4 245.7h-56.3v138.3h92.2l15.3 66.5c5.1 15.4 15.4 25.6 30.7 25.6s25.6-5.1 35.9-20.4l117.7-240.7 20.5 61.5v102.4h35.9l76.8 235.5c5.1 10.2 10.2 20.5 25.6 20.5 10.2 5.1 25.6 0 30.7-10.3l122.9-117.7v-82c-10.2 0-15.4 5.1-20.5 10.3l-112.7 112.6zM921.6 522.2h102.4v138.3h-102.4v-138.3z',
  ],
} satisfies IconDefinition;
